import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNegativeMarginLeft, useNegativeMarginTop } from '../../../hooks/useNegativeMargin/useNegativeMargin';
import { componentsItemMap } from '../../../library/childrenComponentHandler';
import { Box } from '../Box/Box';
import { FlexViewContext } from './FlexViewContext';
export const Container = _a => {
  var {
    children,
    space,
    spaceX,
    spaceY,
    itemsJustifyContent,
    itemsAlignItems,
    className,
    component = 'div'
  } = _a,
      allBoxProps = __rest(_a, ["children", "space", "spaceX", "spaceY", "itemsJustifyContent", "itemsAlignItems", "className", "component"]);

  const negativeMarginLeft = useNegativeMarginLeft(spaceX || space || 'none');
  const negativeMarginTop = useNegativeMarginTop(spaceY || space || 'none');
  return _jsx(Box, Object.assign({
    display: "flex"
  }, allBoxProps, {
    component: component,
    className: [negativeMarginLeft, negativeMarginTop, className]
  }, {
    children: _jsx(FlexViewContext.Provider, Object.assign({
      value: {
        space,
        spaceX,
        spaceY,
        justifyContent: itemsJustifyContent,
        alignItems: itemsAlignItems,
        componentItem: componentsItemMap[component]
      }
    }, {
      children: children
    }))
  }));
};
//# sourceMappingURL=FlexView.js.map